import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import {
  TextField,
  Modal,
  Box,
  Stepper,
  Typography,
  StepLabel,
  Step,
  Button,
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
  Select,
  MenuItem,
  ListItemText,
  List,
  ListItemButton,
  ListItemIcon,
  Collapse,
  IconButton,
  Tooltip,
  Menu,
  Zoom,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import logo from "../../assets/images/logo.png";
import brainicon from "../../assets/images/brain.png";
import success from "../../assets/images/success.gif";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import host from "../../host";
import uploadknowledge from "../../assets/images/uploadknowledge.png";
import chathistory from "../../assets/images/chathistory.png";
import TaskIcon from "@mui/icons-material/Task";
import PageLoader from "../../components/page-loader";
import HistoryLoader from "../../components/loader/history-loader";
import MessageSnackbar from "./snackbar";
import { useDispatch } from "react-redux";
import { changeAuth } from "../../actions/loginAction";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import logoicon from "../../assets/images/logo-icon.png";
import ShareChat from "../../components/share-chat";
import StorageIcon from '@mui/icons-material/Storage';
import { FolderCopyOutlined, PictureAsPdf } from "@mui/icons-material";
import { marked } from 'marked';
// eslint-disable-next-line import/no-webpack-loader-syntax
// import css from 'raw-loader!../../assets/css/style.css';
const steps = ["Type of brain", "Brain params", "Resources"];
export default function SidebarPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [anchorEl, setAnchorEl] = useState(null);
  const [openedChatId, setOpenedChatId] = useState(null);

  const handleClickaction = (event, chatId) => {
    setAnchorEl(event.currentTarget);
    setOpenedChatId(chatId);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenedChatId(null);
  };

  const [isActive, setIsActive] = useState(
    localStorage.getItem("sidebar") === null || localStorage.getItem("sidebar") === "null" || localStorage.getItem("sidebar") === undefined
      ? true
      : localStorage.getItem("sidebar") === "true"
      ? true
      : false
  );
  const handleToggleClick = () => {
    setIsActive(!isActive);
  };
  useEffect(() => {
    localStorage.setItem("sidebar", isActive);
    if (isActive) {
      document.body.classList.add("mini-sidebar");
    } else {
      document.body.classList.remove("mini-sidebar");
    }
  }, [isActive]);

  //this below function for share chat start//
  const [shareId, setShareId] = useState(null);
  const [opensharechat, setOpensharechat] = React.useState(false);
  const activesharechat = () => setOpensharechat(true);
  const handleClosesharechat = () => setOpensharechat(false);
  //this below function for share chat end//

  //sidebar history collapse button
  const [open, setOpen] = useState(true);
  const handleClick = () => {
    setOpen(!open);
    if (isActive === true) {
      setIsActive(false);
      setOpen(true);
    }
  };

  //this below function for openknowledge     popup start//
  const [openknowledge, setOpenknowledge] = React.useState(false);
  const activeknowledge = () => setOpenknowledge(true);
  const handleCloseknowledge = () => setOpenknowledge(false);

  //brain - list functionality begins

  const [brainList, setBrainList] = useState([]);
  const [selectedBrain, setSelectedbrain] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const onClose = () => {
    setSnackbar(false);
  };

  const getbrains = () => {
    // setIsLoaded(false);
    fetch(host.chaturl + `/brain`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          // setIsLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          setBrainList(data);
          // setIsLoaded(true);
        }
      })
      .catch((err) => {
        console.log(err);
        // setIsLoaded(true);
      });
  };

  useEffect(() => {
    if (brainList.length > 0) {
      setSelectedbrain(brainList[0]);
    }
  }, [brainList]);

  useEffect(() => {
    if (openknowledge) {
      getbrains();
    }
  }, [openknowledge]);

  //brain - list functionality ends

  //Add brain functionality begins

  //this below function for add brain   popup start//
  const [openaddbrain, setOpendeleteaddbrain] = React.useState(false);
  const activeaddbrain = () => setOpendeleteaddbrain(true);
  const handleCloseaddbrain = () => setOpendeleteaddbrain(false);
  //this below function for add brain   popup end//

  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const isStepOptional = (step) => {
    return step === 1;
  };
  const isStepSkipped = (step) => {
    return skipped.has(step);
  };
  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };
  const handleReset = () => {
    setActiveStep(0);
  };

  const [brainName, setBrainName] = useState("");
  const [brainDescription, setbrainDescription] = useState("");
  const [isPublic, setIsPublic] = useState("");

  const [brainFile, setBrainFile] = useState(null);
  const [brainFileLoading, setBrainFileLoading] = useState(false);
  const handleBrainFile = (event) => {
    const file = event.target.files[0];
    setBrainFile(file);
  };

  const handleAddBrain = () => {
    if (!brainFile) {
      setSeverity("error");
      setMessage("Please select a file");
      setSnackbar(true);
      return;
    }
    setBrainFileLoading(true);
    const formData = new FormData();
    formData.append("file", brainFile);
    //  formData.append('service', '658bdfee17437eb77206fed6');
    let status;
    if (isPublic) {
      status = "public";
    } else {
      status = "private";
    }

    fetch(host.chaturl + `/brain`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify({
        name: brainName,
        description: brainDescription,
        status: status,
      }),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setBrainFileLoading(false);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          fetch(host.chaturl + `/brain/upload/${data.brain_id}`, {
            method: "POST",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
            body: formData,
          })
            .then((res) => {
              if (res.ok) {
                return res.json();
              } else if (res.status === 403) {
                dispatch(changeAuth(false, null));
                navigate("/logout");
              } else {
                setBrainFileLoading(false);
                setSeverity("error");
                setMessage("Something went wrong");
                setSnackbar(true);
              }
            })
            .then((data) => {
              setBrainFileLoading(false);
              handleNext();
              setBrainFile(null);
            })
            .catch((error) => {
              console.error("Error uploading file:", error);
              setBrainFileLoading(false);
            });
        }
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        setBrainFileLoading(false);
      });
  };

  //Add brain functionality ends

  const [fileLoading, setFileLoading] = useState(false);

  //chat history functionality begins

  const [chatList, setChatList] = useState([]);

  const getChatList = () => {
    setIsLoaded(false);
    fetch(host.chaturl + `/chat`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setIsLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          setChatList(data);
          setIsLoaded(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoaded(true);
      });
  };

  const handleGetChat = (chat_id) => {
    // setPageLoaded(false);
    fetch(host.chaturl + `/chat/${chat_id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          // setPageLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data?.chat_name) {
          // setTitle(data.chat_name);
        } else {
          // setTitle("Untitled");
        }
        if (data) {
          const temp = data.chat_history.flatMap((chat) => {
            return {
              brain: chat.brain_name ? chat.brain_name : "NA",
              request: chat.human ? chat.human : "NA",
              response: chat.ai ? chat.ai : "NA",
              message_id: chat.id,
            };
          });
          // setPageLoaded(true);
          handleDownloadChat(temp, data.chat_name ? data.chat_name : chat_id);
        }
      })
      .catch((err) => {
        console.log(err);
        // setPageLoaded(true);
      });
  };

  const handleDownloadChat = async (chatHistory, title) => {
    const element = document.createElement("div");

    // Convert React components into HTML string
    const chatContent = chatHistory.map(
      (chat, index) => {
        const markdownContent = marked(chat.response); // Convert Markdown to HTML

        return(`<div class="left_chat_content" key=${index}>
        <div class="chat_message_title">
            <h4 style="font-size: 18px;">${chat.request}</h4>
        </div>

        <div class="answer_wrapper chat_sections">
            <div class="sources_title" style="white-space: nowrap;">
                <div class="sourse-icon">
                    <div class="chat_brain" >
                        <img src=${brainicon} alt="" height=${25}/>
                        ${localStorage.getItem("isKnowledgeChat") === "false" ? `<span>${chat.brain ? chat.brain : "NA"}</span>` : ""}
                    </div>
                </div>
                ${localStorage.getItem("isKnowledgeChat") === "false" ? "<span>/</span>" : ""}
                <h5>Answer</h5>
            </div>
            <div class="answer_body">
                <div class="answer_content">${markdownContent}</div>
            </div>
        </div>
    </div>`)
      }
        
    );

    // Join the HTML strings and set as innerHTML
    element.innerHTML = chatContent.join("");

    // Inline the CSS
    // const inlined = juice.inlineContent(element.innerHTML, css);

    // Now `inlined` contains your HTML with inlined CSS
    // You can use it to generate your PDF

    const options = {
      margin: 10,
      filename: "invoice.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      pagebreak: { mode: "avoid-all" },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    // html2pdf().from(inlined).set(options).toPdf().save(`${title}.pdf`);
  };

  useEffect(() => {
    getChatList();
  }, []);

  //delete chat functionality begins

  const handleDeleteChat = (chat_id) => {
    fetch(host.chaturl + `/chat/${chat_id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data.success) {
          setSeverity("success");
          setMessage("Chat deleted successfully");
          setSnackbar(true);
          if(chat_id === localStorage.getItem("chat_id")){
            localStorage.removeItem("chat_id");
            navigate("/home");
          }
          getChatList();
        }
        else{
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //delete chat functionality ends

  //chat history functionality endss

  useEffect(() => {
    if (!localStorage.getItem("login")) {
      navigate("/logout");
    }
  }, [localStorage.getItem("login")]);

  return (
    <>
      <div>
        <MessageSnackbar open={snackbar} autoHideDuration={3000} onClose={onClose} severity={severity} message={message} />
        <div className="sidebar" id="sidebar">
          <div className="sidebar-head">
            <div className="sidebar-logo">
              <Link to="/landing-home">
                <img src={logo} alt="" className="biglogo" />
                <img src={logoicon} className="miniicon" height={35} />
              </Link>
            </div>
            <div className="dhide-mshow">
              <IconButton aria-label="hide" onClick={handleToggleClick}>
                <CloseIcon />
              </IconButton>
            </div>
          </div>

          <div className="sidebar-inner slimscroll">
            <div className="sidebar-double">
              <div className="sidebar-menu menutop">
                <div className="newchatbtn">
                  <Tooltip className="blue-tooltip mb-2 d-block" title="New Chat" placement="top" arrow>
                    <Link
                      to="/home"
                      onClick={() => {
                        localStorage.setItem("chat_id", null);
                        localStorage.setItem("chatTitle", null);
                      }}
                    >
                      <button type="button" className="btn btn-secondary w-100">
                        {" "}
                        <AddIcon /> <span className="newchattitle"> New Chat</span>
                      </button>
                    </Link>
                  </Tooltip>
                </div>
                <ul>
                  <List
                    sx={{ width: "100%", bgcolor: "background.paper" }}
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    // subheader={
                    //   <ListSubheader component="div" id="nested-list-subheader">
                    //     Nested List Items
                    //   </ListSubheader>
                    // }
                  >
                    <Tooltip title="Library" TransitionComponent={Zoom} placement="left" arrow>
                      <ListItemButton component={Link} to="/uploadknowledge" selected={location.pathname === "/uploadknowledge"}>
                        <ListItemIcon sx={{ minWidth: "unset", marginRight: "15px" }}>
                          {/* <BackupOutlinedIcon /> */}
                          <img src={uploadknowledge} alt="" height={22} />
                        </ListItemIcon>
                        <ListItemText primary="Library" />
                      </ListItemButton>
                    </Tooltip>

                    {/* <Tooltip
                      title="Manage Brains"
                      TransitionComponent={Zoom}
                      placement="left"
                      arrow
                    >
                      <ListItemButton
                        component={Link}
                        to="/manage-brains"
                        selected={
                          location.pathname === "/manage-brains" ||
                          location.pathname === `/brain-setting/${id}`
                        }
                      >
                        <ListItemIcon
                          sx={{ minWidth: "unset", marginRight: "15px" }}
                        >
                         
                          <img src={managebrain} alt="" height={22} />
                        </ListItemIcon>
                        <ListItemText primary="Manage Brains" />
                      </ListItemButton>
                    </Tooltip> */}
                    {/* <ListItemButton component={Link} to="" onClick={activeaddbrain}>
                      <ListItemIcon
                        sx={{ minWidth: "unset", marginRight: "15px" }}
                      >
                        <img src={managebrain} alt="" height={25} />
                      </ListItemIcon>
                      <ListItemText primary="Add Brains" />
                    </ListItemButton> */}
                    <Tooltip title="History" TransitionComponent={Zoom} placement="left" arrow>
                      <ListItemButton component={Link} to="#" onClick={handleClick}>
                        <ListItemIcon sx={{ minWidth: "unset", marginRight: "15px" }}>
                          <img src={chathistory} alt="" height={22} />
                        </ListItemIcon>
                        <ListItemText primary="History" />
                        {open ? <ExpandLess className="arrowhistory" /> : <ExpandMore className="arrowhistory" />}
                      </ListItemButton>
                    </Tooltip>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        <div className="sidebar-history">
                          <div className="sidebar-history-body">
                            <div className="chat_history_list">
                              {chatList && chatList.length > 0 && isLoaded ? (
                                Object.entries(
                                  chatList.reduce((accumulator, chat, index) => {
                                    const currentDate = new Date(chat.created_at);
                                    let formattedDate;
                                    let path;

                                    // Check if the date is today
                                    const today = new Date();
                                    if (currentDate.getDate() === today.getDate() && currentDate.getMonth() === today.getMonth() && currentDate.getFullYear() === today.getFullYear()) {
                                      formattedDate = "Today";
                                    }
                                    // Check if the date is yesterday
                                    else if (currentDate.getDate() === today.getDate() - 1 && currentDate.getMonth() === today.getMonth() && currentDate.getFullYear() === today.getFullYear()) {
                                      formattedDate = "Yesterday";
                                    }
                                    // Otherwise, format the date as dd-mm-yyyy
                                    else {
                                      {
                                        /* formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`; */
                                      }
                                      const day = ("0" + currentDate.getDate()).slice(-2);
                                      const month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
                                      const year = currentDate.getFullYear();
                                      formattedDate = `${day}-${month}-${year}`;
                                    }

                                    if (!accumulator[formattedDate]) {
                                      accumulator[formattedDate] = [];
                                    }

                                    if (chat.chat_type === null) {
                                      if (chat.knowledges.length === 0) {
                                        path = `/brainChat/${chat.id}`;
                                      } else {
                                        path = `/knowledgeChat/${chat.id}`;
                                      }
                                    } else if (chat.chat_type) {
                                      if (chat.chat_type === "brain") {
                                        path = `/brainChat/${chat.id}`;
                                      } else if (chat.chat_type === "knowledge") {
                                        path = `/knowledgeChat/${chat.id}`;
                                      } else if (chat.chat_type === "browser") {
                                        path = `/browserHome/${chat.id}`;
                                      } else if (chat.chat_type === "database") {
                                        path = `/databaseChat/${chat.id}`;
                                      }
                                       
                                    }

                                    accumulator[formattedDate].push(
                                      <li key={index}>
                                        <Link
                                          to={path}
                                          className={location.pathname === path ? "active" : ""}
                                          onClick={() => {
                                            localStorage.setItem("chat_id", chat.id);
                                          }}
                                        >
                                          <div className="">
                                            {chat.chat_type === null ? (
                                              chat.knowledges.length === 0 ? (
                                                <FolderCopyOutlined style={{ fontSize: "16px", marginRight: "5px" }} />
                                              ) : (
                                                <PictureAsPdf style={{ fontSize: "16px", marginRight: "5px" }} />
                                              )
                                            ) : chat.chat_type === "brain" ? (
                                              <FolderCopyOutlined style={{ fontSize: "16px", marginRight: "5px" }} />
                                            ) : chat.chat_type === "database" ? (
                                              <StorageIcon style={{ fontSize: "16px", marginRight: "5px" }} />
                                            ) : chat.chat_type === "knowledge" ? (
                                              <PictureAsPdf style={{ fontSize: "16px", marginRight: "5px" }} />
                                            ) : chat.chat_type === "browser" ? (
                                              <TravelExploreIcon style={{ fontSize: "16px", marginRight: "5px" }} />
                                            ) : null}
                                          </div>
                                          <div className="history_line">{chat.chat_name ? chat.chat_name : "NA"}</div>
                                        </Link>
                                        <div className="history_action">
                                          <Tooltip title="Actions">
                                            <Link
                                              onClick={(event) => handleClickaction(event, chat.id)}
                                              size="small"
                                              aria-controls={open ? "account-menu" : ""}
                                              aria-haspopup="true"
                                              aria-expanded={open ? "true" : "false"}
                                            >
                                              <MoreHorizIcon />
                                            </Link>
                                          </Tooltip>
                                          <Menu
                                            anchorEl={anchorEl}
                                            id="account-menu"
                                            open={openedChatId === chat.id}
                                            onClose={handleClose}
                                            onClick={handleClose}
                                            PaperProps={{
                                              elevation: 0,
                                              sx: {
                                                overflow: "visible",
                                                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                                                mt: 1.5,
                                                "& .MuiAvatar-root": {
                                                  width: 32,
                                                  height: 32,
                                                  ml: -0.5,
                                                  mr: 1,
                                                },
                                                "&::before": {
                                                  content: '""',
                                                  display: "block",
                                                  position: "absolute",
                                                  top: 0,
                                                  right: 14,
                                                  width: 10,
                                                  height: 10,
                                                  bgcolor: "background.paper",
                                                  transform: "translateY(-50%) rotate(45deg)",
                                                  zIndex: 0,
                                                },
                                              },
                                            }}
                                            transformOrigin={{
                                              horizontal: "right",
                                              vertical: "top",
                                            }}
                                            anchorOrigin={{
                                              horizontal: "right",
                                              vertical: "bottom",
                                            }}
                                          >
                                            <MenuItem
                                              onClick={() => {
                                                setShareId(chat.id);
                                                activesharechat();
                                              }}
                                            >
                                              <ListItemIcon>
                                                <ShareOutlinedIcon fontSize="small" />
                                              </ListItemIcon>
                                              Share Chat
                                            </MenuItem>
                                            <MenuItem
                                              onClick={() => {
                                                handleGetChat(chat.id);
                                              }}
                                            >
                                              <ListItemIcon>
                                                <FileDownloadOutlinedIcon fontSize="small" />
                                              </ListItemIcon>
                                              Download Chat
                                            </MenuItem>
                                            <MenuItem
                                              onClick={() => {
                                                handleDeleteChat(chat.id);
                                              }}
                                            >
                                              <ListItemIcon>
                                                <DeleteOutlineOutlinedIcon fontSize="small" />
                                              </ListItemIcon>
                                              Delete Chat
                                            </MenuItem>
                                          </Menu>
                                        </div>
                                      </li>
                                    );
                                    return accumulator;
                                  }, {})
                                ).map(([date, chats]) => (
                                  <div key={date} className="list_box">
                                    <div className="list_title">{date}</div>
                                    <ul>{chats}</ul>
                                  </div>
                                ))
                              ) : (
                                <li>
                                  <div className="history_line"> No Chats Available </div>
                                </li>
                              )}
                              {!isLoaded && <HistoryLoader />}
                            </div>
                          </div>
                        </div>
                      </List>
                    </Collapse>
                  </List>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <Modal open={openknowledge} onClose={handleCloseknowledge} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <Box className=" commonpopup  modal-common   popup-w50 ">
        
              <div className="card-item__content    ">
                <div className="card-title">
                  <h2>Explore uploaded data</h2>
                  <span>View, download or delete knowledge used by your brain</span>
                </div>
                <Link className="close" onClick={handleCloseknowledge}>
                  X
                </Link>
              </div>
              <div className="modal-body">
                <div className="popup_scroller">

           
              <div className="popup-knowledge">
                {!fileLoading ? (
                  <>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Select Brain</label>
                        <FormControl fullWidth size="small">
                          {brainList.length > 0 && (
                            <Select labelId="demo-select-small-label" id="demo-select-small" value={selectedBrain ? selectedBrain.id : brainList[0].id}>
                              <MenuItem value={0}>Select Brain</MenuItem>
                              {brainList &&
                                brainList.length > 0 &&
                                brainList.map((brain) => {
                                  return (
                                    <MenuItem
                                      value={brain.id}
                                      onClick={() => {
                                        setSelectedbrain(brain);
                                      }}
                                    >
                                      {brain.name ? brain.name : "NA"}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          )}
                        </FormControl>
                      </div>
                    </div>
                  </>
                ) : (
                  <PageLoader />
                )}
              </div>
              </div>
            </div>
          </Box>
        </Modal>
      </div>
      <Modal open={openaddbrain} onClose={handleCloseaddbrain} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box className=" commonpopup  modal-common   popup-w50 ">
      
            <div className="card-item__content   ">
              <div className="card-title">
                <h2>Add New Brain</h2>
                <span>Create a new space for your data</span>
              </div>
              <Link className="close" onClick={handleCloseaddbrain}>
                X
              </Link>
            </div>
            <div className="modal-body">
            <div className="popup_scroller">
            <div className="add_brain-step_wrapper">
              <div className="step_head">
                <Stepper activeStep={activeStep}>
                  {steps.map((label, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    if (isStepOptional(index)) {
                      labelProps.optional = <Typography variant="caption"> </Typography>;
                    }
                    if (isStepSkipped(index)) {
                      stepProps.completed = false;
                    }
                    return (
                      <Step key={label} {...stepProps}>
                        <StepLabel {...labelProps}>{label}</StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
              </div>
              <div className="add_brain_body">
                {activeStep === steps.length ? (
                  <React.Fragment>
                    <div className="finish-steps" sx={{ mt: 2, mb: 1 }}>
                      <div className="step-successbox">
                        <div className="success-stepicon">
                          <img className=" " src={success} alt="sender-icon" />
                        </div>
                        <div className="success-stepmessage">
                          <h5> Add brain process complete</h5>
                        </div>
                      </div>
                    </div>
                    <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                      <Box sx={{ flex: "1 1 auto" }} />
                      <Button onClick={handleReset}>Reset</Button>
                    </Box>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {activeStep === 0 && (
                      <div className="steps-content">
                        <div className="row">
                          <div className="col-12">
                            <div className="form-group">
                              <label> Knowledge source</label>
                              <FormControl>
                                <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
                                  <FormControlLabel value="Documents" control={<Radio checked={true} />} label="Documents" />
                                  <FormControlLabel value="API" control={<Radio checked={false} />} label="API (Through API)" />
                                </RadioGroup>
                              </FormControl>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {activeStep === 1 && (
                      <div className="steps-content">
                        <div className="row">
                          <div className="col-12">
                            <div className="form-group">
                              <label>
                                Brain Name <span className="text-danger">*</span>
                              </label>
                              <TextField
                                id="outlined-basic"
                                type="text"
                                placeholder="Enter brain name"
                                size="small"
                                value={brainName}
                                onChange={(e) => {
                                  setBrainName(e.target.value);
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="form-group">
                              <label>Brain Description </label>
                              <TextField
                                id="outlined-basic"
                                type="text"
                                placeholder="Enter brain name"
                                multiline
                                rows={4}
                                value={brainDescription}
                                onChange={(e) => {
                                  setbrainDescription(e.target.value);
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="form-group">
                              <label> Access</label>
                              <FormControl>
                                <RadioGroup aria-label="options" name="options" row>
                                  <div className="radio-text">
                                    <FormControlLabel
                                      value="option1"
                                      control={
                                        <Radio
                                          checked={isPublic}
                                          onClick={() => {
                                            setIsPublic(true);
                                          }}
                                        />
                                      }
                                      label="Public"
                                    />
                                    <span className="shortcontent">The brain will be shared with the ChatBot community</span>
                                  </div>
                                  <div className="radio-text">
                                    <FormControlLabel
                                      value="option2"
                                      control={
                                        <Radio
                                          checked={!isPublic}
                                          onClick={() => {
                                            setIsPublic(false);
                                          }}
                                        />
                                      }
                                      label="Private"
                                    />
                                    <span className="shortcontent">Accessible for you and the people you share it with</span>
                                  </div>
                                </RadioGroup>
                              </FormControl>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {activeStep === 2 && (
                      <div className="steps-content">
                        <div className="col-md-12">
                          <div className="whatpdf_wrapper">
                            {!brainFileLoading && (
                              <>
                                <div className="whatpdf_title">
                                  <h3>Explore uploaded data</h3>
                                  <p>View, download or delete knowledge used by your brain</p>
                                </div>
                                <div className="csv-upload ">
                                  {/* <div className="fileprogress">
                                  <LinearProgress
                                    variant="determinate"
                                    value={progress}
                                  />
                                </div> */}
                                  <div className="upload-pdf">
                                    <label htmlFor="file-upload1">
                                      <input type="file" id="file-upload1" style={{ visibility: "hidden" }} onChange={handleBrainFile} />
                                      {brainFile === null ? (
                                        <>
                                          <div className="svg-circle">
                                            <FileUploadOutlinedIcon />
                                          </div>
                                          <h5> Drag and drop PDF files to upload </h5>
                                          <p>Your PDF will be private until you publish them. </p>
                                        </>
                                      ) : (
                                        <>
                                          <div className="svg-circle">
                                            <TaskIcon />
                                          </div>
                                          <h5> {brainFile ? brainFile.name : ""} </h5>
                                        </>
                                      )}
                                    </label>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center  w-100 mt-4  ">
                                  <hr className="flex-grow-1 bg-dark-4 bg-white m-0" />
                                  <span className="mx-2 text-2 text-muted p-0">OR </span>
                                  <hr className="flex-grow-1 bg-dark-4 m-0" />
                                </div>
                                <div className="upload-other">
                                  <div className="form-group">
                                    <label>From URL </label>
                                    <div className="url-search">
                                      <div className="search-url ">
                                        <div className="chat_form_flexbox">
                                          <div className="messageform">
                                            <TextField id="outlined-multiline-flexible" placeholder="https://example.com/file.pdf" />
                                          </div>
                                          <div className="send_btn">
                                            <Link to="/chat-pdf-view">
                                              <button type="button" className="senderbtn">
                                                <SendOutlinedIcon />
                                              </button>
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                            {brainFileLoading && <PageLoader />}
                          </div>
                        </div>
                      </div>
                    )}
                    <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                      <Button color="inherit" disabled={activeStep === 0} onClick={handleBack} sx={{ mr: 1 }}>
                        Back
                      </Button>
                      <Box sx={{ flex: "1 1 auto" }} />
                      {isStepOptional(activeStep) && (
                        <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                          Skip
                        </Button>
                      )}
                      <Button
                        disabled={fileLoading}
                        onClick={() => {
                          if (activeStep === steps.length - 1) {
                            handleAddBrain();
                          } else {
                            handleNext();
                          }
                        }}
                      >
                        {activeStep === steps.length - 1 ? "Finish" : "Next"}
                      </Button>
                    </Box>
                  </React.Fragment>
                )}
              </div>
            </div>
            </div>
          </div>
        </Box>
      </Modal>
      <ShareChat opensharechat={opensharechat} handleClosesharechat={handleClosesharechat} chatId={shareId} />
    </>
  );
}
